import gql from "graphql-tag";

export const CREATE_JIRA_ACTIVITY = gql`
  mutation($input: createJiraActivityInput) {
    createJiraActivity(input: $input) {
      _id
      title
      description
      created_by {
        _id
        email
        full_name
      }
      project {
        _id
        title
      }
      activity_type
      meta
      time {
        start
        paused {
          created_at
          time
          continue
        }
      }
    }
  }
`;
